/* eslint-disable */
<template>
  <div>
    <div class="container-fluid w-100 no-padding">
      <div class="row">
        <div class="col-md-12">
          <v-wait for="teklifler-loading">
            <template slot="waiting">
              <div class="vue-wait-class">
                <img src="static/loading.svg" />
                <p>Veriler yükleniyor...</p>
              </div>
            </template>
            <table class="table table-bordered">
              <thead class="thead-light">
                <tr>
                  <th style="width: 32px;" scope="col">#</th>
                  <th style="width: 10%;" scope="col">MÜŞTERİ</th>
                  <th style="width: 20%;" scope="col">FİRMA BİLGİSİ</th>
                  <th style="width: 10%;" scope="col">TELEFON</th>
                  <th style="width: 10%;" scope="col">E-POSTA</th>
                  <th style="width: auto;" scope="col">MESAJ</th>
                  <th style="width: 15%;" scope="col">TARİH</th>
                </tr>
              </thead>
              <tbody class="tbody-margin">
                <template v-for="(demoreq, index) in demoRequests">
                  <tr :key="'trow-first-' + demoreq.ID">
                    <td class="align-middle">{{demoreq.ID}}</td>
                    <td class="align-middle">{{demoreq.Name}}</td>
                    <td class="align-middle">{{demoreq.Company}}</td>
                    <td class="align-middle">{{demoreq.GsmNo}}</td>
                    <td class="align-middle">{{demoreq.EMail}}</td>
                    <td class="align-middle">{{demoreq.Message}}</td>
                    <td class="align-middle">{{demoreq.Created_Formatted}}</td>
                  </tr>
                </template>
              </tbody>
            </table>
          </v-wait>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from 'axios'

export default {
  name: 'DemoTalepleri',
  data () {
    return {
      messageText: '',

      demoRequests: [],
      toastOptions: {
        theme: "bubble",
        position: "top-center",
        duration : 4000
      },
    }
  },
  computed: {
    getPersonelId : function() { return this.$store.getters.getPersonelId },
    getSessionId : function() { return this.$store.getters.getSessionId },
  },
  methods: {
    getDemoRequests() {
      this.$wait.start('demo-requests-loading');

      axios
      .get('/api/bids/demo-requests')
      .then(response => {
        this.demoRequests = response.data
        this.$wait.end('demo-requests-loading')
      })
      .catch(error => {
        console.log(error)
        this.$wait.end('demo-requests-loading')
      })
    },
    getDemoRequestById() {
      this.$wait.start('demo-request-loading');

      axios
      .get('/api/bids/' + this.selectedTeklifId)
      .then(response => {
        this.selectedTeklif = response.data[0]
        this.$wait.end('demo-request-loading')
      })
      .catch(error => {
        console.log(error)
        this.$wait.end('demo-request-loading')
      })
    },
    updateDemoRequestById() {
      this.$wait.start('demo-request-loading');
      this.selectedTeklif.Status = parseInt(this.selectedTeklif.Status);

      axios
      .put('/api/bids/' + this.selectedTeklifId, this.selectedTeklif)
      .then(response => {
        this.$wait.end('demo-request-loading')
        this.getDemoRequests()
      })
      .catch(error => {
        console.log(error)
        this.$wait.end('demo-request-loading')
      })
    },
    cropData(val, len) { 
      if(val == null || val == undefined)
        return null;

      if((val.length + 3) > len) return val.substring(0, len) + '...' 
      else return val
    },
    parseOfferProduct(product) {
      if (product == 1)
        return "Lenoi Max";
      else if (product == 2)
        return "Lenoi PRO";
      else if (product == 3)
        return "HX10 NVR";
      else if (product == 4)
        return "HX11 NVR";
      else if (product == 5)
        return "HX12 NVR";
      else if (product == 6)
        return "LNX66 IP Kamera";
      else return "Tanımsız";
    },
    parseOfferStatus(status) {
      if (status == 0)
        return "Teklif Bekliyor";
      else if (status == 1)
        return "Yanıt Bekleniyor";
      else if (status == 2)
        return "Zaman Aşımı";
      else if (status == 3)
        return "Satışa Dönüştü";
      else if (status == 4)
        return "Reddedildi";
      else return "Tanımsız";
    },
    parseOfferStatusClass(status) {
      if (status == 0)
        return "badge-primary";
      else if (status == 1)
        return "badge-warning";
      else if (status == 2)
        return "badge-secondary";
      else if (status == 3)
        return "badge-success";
      else if (status == 4)
        return "badge-danger";
      else return "Tanımsız";
    },
    openModalforDemoRequest(id) {
      this.selectedDemoRequestId = id
      this.getDemoRequestById()
    }
  },
  mounted() {
    this.getDemoRequests()
  }
}
</script>

<style scoped>

  div.icon-global {
    position: absolute;
    z-index: 3;
    margin-left: -36px;
    margin-top: 24px;
    width: 30px;
    height: 30px;
    padding: 4px 4px 5px 4px;
    border-radius: 15px;
  }

  div.icon-global.bg-danger {
    margin-top: -6px !important;
  }

  div.icon-global i {
    color: #FFF;
  }

  .margin-negative {
    margin-bottom: -4px !important;
  }

  input.btn-more-radius {
    text-indent: 10px;
  }

  .table-row {
    display: block;
    width: 100%;
  }
  
  table { caption-side: top !important; }
  table, .dropdown-item {
    font-size: .875rem;
  }

  td .btn {
    font-size: 0.875rem;
  }

  td a.btn {
    font-size: .875rem;
  }

  .btn i {
    color: #FFF;
  }

  .btn:hover i {
    color: #FFF !important;
  }

  tr.collapsed-row {
    background: #F0F0F0;
    /*-webkit-box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);
    -moz-box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);
    box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);*/
  }

  span.badge {
    font-size: 100%;
    font-weight: 400;
  }

  .vue-wait-class {
    display: block;
    width: 300px;
    text-align: center;
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
  }

  .vue-wait-class img {
    width: 160px;
    height: 160px;
    margin: 10px auto 0 auto;
    clear: both;
  }

  .vue-wait-class p {
    width: 100%;
    text-align: center;
    font-size: 20px;
  }

  .no-padding {
    padding: 0;
    margin: 0;
  }

  .no-padding .row {
    margin: 0;
  }

  .no-padding .row .col-md-12, .no-padding .row .col-md-9, .no-padding .row .col-md-3 {
    margin: 0 !important;
    padding: 0 !important;
  }

  .caption {
    font-size: 15px;
    font-weight: 700;
    color: #e9ecef;
    background-color: #010929;
    vertical-align: center;
    padding: 11px 15px 12px 15px;
  }
  
  .conversation-view {
    display: block;
    position: absolute;
    z-index: 2;
    width: 350px;
    height: 70%;
    left: 3%;
    bottom: 4.5%;
    border: 1px solid #dee2e6;

    -webkit-box-shadow: 0px 10px 30px -4px rgba(200,200,200,1);
    -moz-box-shadow: 0px 10px 30px -4px rgba(200,200,200,1);
    box-shadow: 0px 10px 30px -4px rgba(200,200,200,1); 
  }

  .bubble span {
    display: inline-block;
    min-width: 120px !important;
    width: auto;
    max-width: 70%;
    padding: 6px 20px;
    color: #fff;
    background-color: #007bff;
    border-radius: 30px;
  }

  .bubble small {
    display: block;
    width: 100%;
    margin-left: 8px;
    font-size: 75%;
  }

  .bubble.own span {
    background-color: #e83e8c;
  }

  .bubble.own small {
    margin-right: 8px;
  }

  .modal-body-fixed {
    height: 300px;
    max-height: 300px !important;
    overflow: auto;
  }

  .overflow-y {
    min-height: 100%;
    overflow: auto !important;
  }

  .text-truncated {
    display: block !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
  }

</style>


// WEBPACK FOOTER //
// src/components/DemoTalepleriPage.vue